var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    _vm._b({}, "div", _vm.$attrs, false),
    [
      _c("FormsAutocomplete", {
        attrs: {
          item: _setup.collection,
          label: _vm.label,
          disabled: _vm.disabled,
          "error-messages": _vm.errorMessages,
          dense: _vm.dense,
          outlined: _vm.outlined,
          "store-action": "domainTeacherIndicator/ActionIndexVariationStatuses",
          "return-object": _vm.returnObject,
          "load-data": _vm.loadData,
          "show-add": _vm.showAdd,
          columns: _vm.columns,
          clearable: _vm.clearable,
        },
        on: {
          onShowFormCreate: (value) => (_setup.showFormCreate = value),
          change: (value) => _setup.emit("change", value),
        },
        model: {
          value: _setup.model,
          callback: function ($$v) {
            _setup.model = $$v
          },
          expression: "model",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }